import { render, staticRenderFns } from "./edit-keyword-auto-response.vue?vue&type=template&id=1c595c28&scoped=true&"
import script from "./edit-keyword-auto-response.vue?vue&type=script&lang=js&"
export * from "./edit-keyword-auto-response.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c595c28",
  null
  
)

export default component.exports